module.exports = __webpack_public_path__ + "media/images/v4/play-btn-88fa428def8fe983d2a059d8ebd2b256.png";